import { render } from "./WorkflowManagementComponent.vue?vue&type=template&id=37d7a3bb&scoped=true"
import script from "./WorkflowManagementComponent.vue?vue&type=script&lang=js"
export * from "./WorkflowManagementComponent.vue?vue&type=script&lang=js"

import "./WorkflowManagementComponent.vue?vue&type=style&index=0&id=37d7a3bb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37d7a3bb"]])

export default __exports__